(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('AgreementValuationDialogController', AgreementValuationDialogController);

    AgreementValuationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AgreementValuation'];

    function AgreementValuationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AgreementValuation) {
        var vm = this;
        vm.agreementValuation = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:agreementValuationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.agreementValuation.id !== null) {
                AgreementValuation.update(vm.agreementValuation, onSaveSuccess, onSaveError);
            } else {
                AgreementValuation.save(vm.agreementValuation, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
